import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TmsAmbarBlokService } from '../ctl-tms-ambar-blok.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private tmsAmbarBlokService : TmsAmbarBlokService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
            ]);

            const filterArr = [];
            if (this.tmsAmbarBlokService.ambarCode) filterArr.push(['AmbarKod', '=', this.tmsAmbarBlokService.ambarCode]);
            if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
